import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  withStyles
} from '@material-ui/core'
import { NumericFormat } from 'react-number-format'

const CustomTextField = withStyles({
  root: {
    '& fieldset.MuiOutlinedInput-notchedOutline': {
      border: 'var(--border-neutral-normal)',
      borderRadius: 'var(--border-radius-sm)'
    },
    '& .Mui-disabled > .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--border-neutral-disabled)'
    },
    '& .Mui-disabled': {
      '&:hover': {
        cursor: 'not-allowed'
      }
    }
  }
})(TextField)

function CustomNumericInput ({
  onValueChange,
  suffix,
  value,
  defaultValue,
  isAllowed
}, ref) {
  const materialUITextFieldProps = {
    variant: 'outlined'
  }
  return (
    <NumericFormat
      valueIsNumericString
      suffix={suffix}
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      isAllowed={isAllowed}
      onValueChange={onValueChange}
      customInput={CustomTextField}
      {...materialUITextFieldProps}
    />
  )
}

const NumericInput = React.forwardRef(CustomNumericInput)

CustomNumericInput.propTypes = {
  onValueChange: PropTypes.func,
  isAllowed: PropTypes.func,
  suffix: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string
}

export default NumericInput
